<template>
  <div class="content">
    <div class="contentPrincipal" style="display: flex; flex-direction: row; padding: 0; overflow: hidden;">
      <!-- Mini sidebar de navigation doc -->
      <div class="doc-nav-sidebar monElement">
        <div class="doc-nav-header">
          <span class="material-icons-sharp" style="color: var(--color-primary); font-size: 22px">menu_book</span>
          <span class="doc-nav-title">Documentation</span>
        </div>

        <!-- Barre de recherche rapide -->
        <div class="doc-search-box">
          <span class="material-icons-sharp" style="font-size:16px;color:#999">search</span>
          <input
            v-model="searchQuery"
            type="text"
            placeholder="Rechercher une page…"
            class="doc-search-input"
          />
          <span
            v-if="searchQuery"
            class="material-icons-sharp doc-search-clear"
            @click="searchQuery = ''"
          >close</span>
        </div>

        <template v-if="!searchQuery">
        <div class="doc-nav-group-label">Général</div>
        <div
          v-for="item in generalNav"
          :key="item.key"
          :class="['doc-nav-item', { 'doc-nav-active': currentPage === item.key }]"
          @click="navigate(item.key)"
        >
          <span class="material-icons-sharp">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </div>

        <div class="doc-nav-group-label">Modules</div>
        <div
          v-for="item in modulesNav"
          :key="item.key"
          :class="['doc-nav-item', { 'doc-nav-active': currentPage === item.key }]"
          @click="navigate(item.key)"
        >
          <span class="material-icons-sharp">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </div>

        <div class="doc-nav-group-label">Annexes</div>
        <div
          v-for="item in annexesNav"
          :key="item.key"
          :class="['doc-nav-item', { 'doc-nav-active': currentPage === item.key }]"
          @click="navigate(item.key)"
        >
          <span class="material-icons-sharp">{{ item.icon }}</span>
          <span>{{ item.label }}</span>
        </div>
        </template>

        <!-- Résultats de recherche -->
        <template v-else>
          <div class="doc-nav-group-label">Résultats</div>
          <div
            v-for="item in filteredNav"
            :key="'search-' + item.key"
            :class="['doc-nav-item', { 'doc-nav-active': currentPage === item.key }]"
            @click="navigate(item.key); searchQuery = ''"
          >
            <span class="material-icons-sharp">{{ item.icon }}</span>
            <span>{{ item.label }}</span>
          </div>
          <div v-if="filteredNav.length === 0" class="doc-nav-empty">
            Aucun résultat
          </div>
        </template>
      </div>

      <!-- Zone de contenu doc -->
      <div class="doc-main-area monElement" ref="docMainArea">
        <!-- Breadcrumb -->
        <div class="doc-breadcrumb-bar">
          <span class="material-icons-sharp" style="font-size: 16px; color: var(--color-primary)">menu_book</span>
          <span>Documentation</span>
          <span class="material-icons-sharp" style="font-size: 14px">chevron_right</span>
          <span style="color: var(--color-primary); font-weight: 600">{{ currentPageLabel }}</span>
        </div>

        <!-- Contenu de la page -->
        <transition name="fade" mode="out-in">
          <component :is="currentComponent" :key="currentPage" />
        </transition>

        <!-- Navigation précédent / suivant -->
        <div class="doc-page-nav">
          <div
            class="doc-page-nav-btn"
            v-if="prevPage"
            @click="navigate(prevPage.key)"
          >
            <span class="material-icons-sharp">arrow_back</span>
            <div>
              <small>Précédent</small>
              <span>{{ prevPage.label }}</span>
            </div>
          </div>
          <div v-else></div>
          <div
            class="doc-page-nav-btn"
            v-if="nextPage"
            @click="navigate(nextPage.key)"
          >
            <div style="text-align: right">
              <small>Suivant</small>
              <span>{{ nextPage.label }}</span>
            </div>
            <span class="material-icons-sharp">arrow_forward</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="doc-footer">
          <p><strong>SGI ABIAPHAR Distribution</strong> — Manuel d'utilisation</p>
          <p>© 2026 ABIAPHAR Distribution. Tous droits réservés.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocIntroduction from "../components/documentation/DocIntroduction.vue";
import DocConnexion from "../components/documentation/DocConnexion.vue";
import DocInterface from "../components/documentation/DocInterface.vue";
import DocRoles from "../components/documentation/DocRoles.vue";
import DocTableauDeBord from "../components/documentation/DocTableauDeBord.vue";
import DocParametrage from "../components/documentation/DocParametrage.vue";
import DocApprovisionnement from "../components/documentation/DocApprovisionnement.vue";
import DocStocks from "../components/documentation/DocStocks.vue";
import DocClients from "../components/documentation/DocClients.vue";
import DocCommandes from "../components/documentation/DocCommandes.vue";
import DocCaisse from "../components/documentation/DocCaisse.vue";
import DocComptabilite from "../components/documentation/DocComptabilite.vue";
import DocSortieArgent from "../components/documentation/DocSortieArgent.vue";
import DocInventaire from "../components/documentation/DocInventaire.vue";
import DocPertes from "../components/documentation/DocPertes.vue";
import DocRetour from "../components/documentation/DocRetour.vue";
import DocReduction from "../components/documentation/DocReduction.vue";
import DocEstimation from "../components/documentation/DocEstimation.vue";
import DocStatistiques from "../components/documentation/DocStatistiques.vue";
import DocRaccourcis from "../components/documentation/DocRaccourcis.vue";
import DocFaq from "../components/documentation/DocFaq.vue";
import DocSupport from "../components/documentation/DocSupport.vue";

export default {
  name: "DocumentationView",
  components: {
    DocIntroduction,
    DocConnexion,
    DocInterface,
    DocRoles,
    DocTableauDeBord,
    DocParametrage,
    DocApprovisionnement,
    DocStocks,
    DocClients,
    DocCommandes,
    DocCaisse,
    DocComptabilite,
    DocSortieArgent,
    DocInventaire,
    DocPertes,
    DocRetour,
    DocReduction,
    DocEstimation,
    DocStatistiques,
    DocRaccourcis,
    DocFaq,
    DocSupport,
  },
  data() {
    return {
      currentPage: "introduction",
      searchQuery: "",
      generalNav: [
        { key: "introduction", icon: "info", label: "Introduction" },
        { key: "connexion", icon: "login", label: "Connexion" },
        { key: "interface", icon: "dashboard", label: "Interface générale" },
        { key: "roles", icon: "group", label: "Rôles & Permissions" },
      ],
      modulesNav: [
        { key: "tableau-de-bord", icon: "home", label: "Tableau de bord" },
        { key: "parametrage", icon: "construction", label: "Paramétrage" },
        { key: "approvisionnement", icon: "production_quantity_limits", label: "Approvisionnement" },
        { key: "stocks", icon: "warehouse", label: "Gestion des stocks" },
        { key: "clients", icon: "person_outline", label: "Gestion des clients" },
        { key: "commandes", icon: "grading", label: "Bons de commande" },
        { key: "caisse", icon: "point_of_sale", label: "Caisse" },
        { key: "comptabilite", icon: "account_balance_wallet", label: "Comptabilité" },
        { key: "sortie-argent", icon: "payments", label: "Sortie d'argent" },
        { key: "inventaire", icon: "receipt_long", label: "Inventaire" },
        { key: "pertes", icon: "rule", label: "Produits déficit / Pertes" },
        { key: "retour", icon: "low_priority", label: "Retour produit" },
        { key: "reduction", icon: "reduce_capacity", label: "Bonus de fidélité" },
        { key: "estimation", icon: "price_check", label: "Tracking / Estimation" },
        { key: "statistiques", icon: "trending_up", label: "Statistiques" },
      ],
      annexesNav: [
        { key: "raccourcis", icon: "keyboard", label: "Raccourcis & Astuces" },
        { key: "faq", icon: "help_outline", label: "FAQ" },
        { key: "support", icon: "support_agent", label: "Support technique" },
      ],
    };
  },
  computed: {
    allNav() {
      return [...this.generalNav, ...this.modulesNav, ...this.annexesNav];
    },
    currentIndex() {
      return this.allNav.findIndex((n) => n.key === this.currentPage);
    },
    filteredNav() {
      if (!this.searchQuery) return this.allNav;
      const q = this.searchQuery.toLowerCase();
      return this.allNav.filter(
        (n) => n.label.toLowerCase().includes(q) || n.key.toLowerCase().includes(q)
      );
    },
    prevPage() {
      return this.currentIndex > 0 ? this.allNav[this.currentIndex - 1] : null;
    },
    nextPage() {
      return this.currentIndex < this.allNav.length - 1
        ? this.allNav[this.currentIndex + 1]
        : null;
    },
    currentPageLabel() {
      const found = this.allNav.find((n) => n.key === this.currentPage);
      return found ? found.label : "";
    },
    currentComponent() {
      const map = {
        introduction: "DocIntroduction",
        connexion: "DocConnexion",
        interface: "DocInterface",
        roles: "DocRoles",
        "tableau-de-bord": "DocTableauDeBord",
        parametrage: "DocParametrage",
        approvisionnement: "DocApprovisionnement",
        stocks: "DocStocks",
        clients: "DocClients",
        commandes: "DocCommandes",
        caisse: "DocCaisse",
        comptabilite: "DocComptabilite",
        "sortie-argent": "DocSortieArgent",
        inventaire: "DocInventaire",
        pertes: "DocPertes",
        retour: "DocRetour",
        reduction: "DocReduction",
        estimation: "DocEstimation",
        statistiques: "DocStatistiques",
        raccourcis: "DocRaccourcis",
        faq: "DocFaq",
        support: "DocSupport",
      };
      return map[this.currentPage] || "DocIntroduction";
    },
  },
  methods: {
    navigate(key) {
      this.currentPage = key;
      this.$nextTick(() => {
        if (this.$refs.docMainArea) this.$refs.docMainArea.scrollTop = 0;
      });
    },
  },
};
</script>

<style scoped>
/* ====== Nav sidebar dans le contentPrincipal ====== */
.doc-nav-sidebar {
  width: 260px;
  min-width: 260px;
  height: calc(100vh - 140px);
  overflow-y: auto;
  border-right: 1px solid #e0e0e0;
  padding: 0;
  background: var(--color-white, #fff);
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 transparent;
}

.doc-nav-sidebar::-webkit-scrollbar {
  width: 4px;
}
.doc-nav-sidebar::-webkit-scrollbar-track {
  background: transparent;
}
.doc-nav-sidebar::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 4px;
}

.doc-nav-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 16px;
  border-bottom: 2px solid var(--color-primary, #e9ae53);
}

/* Search box */
.doc-search-box {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 10px 12px 4px;
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: var(--color-background, #f5f5f9);
  transition: border-color 0.2s;
}

.doc-search-box:focus-within {
  border-color: var(--color-primary, #e9ae53);
}

.doc-search-input {
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  color: var(--color-dark, #363949);
  width: 100%;
  font-family: inherit;
}

.doc-search-input::placeholder {
  color: #bbb;
}

.doc-search-clear {
  font-size: 14px !important;
  color: #bbb;
  cursor: pointer;
  transition: color 0.15s;
}

.doc-search-clear:hover {
  color: #666;
}

.doc-nav-empty {
  padding: 20px 16px;
  text-align: center;
  font-size: 12px;
  color: #999;
}

.doc-nav-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-dark, #363949);
}

.doc-nav-group-label {
  padding: 14px 16px 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: var(--color-info-dark, #7c8894);
}

.doc-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  font-size: 12.5px;
  color: var(--color-dark-variant, #677483);
  cursor: pointer;
  border-left: 3px solid transparent;
  transition: all 0.15s;
}

.doc-nav-item:hover {
  background: var(--color-primary-solve, #e9ae5329);
  color: var(--color-primary-hard, #916c3a);
}

.doc-nav-item.doc-nav-active {
  background: var(--color-primary-solve, #e9ae5329);
  color: var(--color-primary-hard, #916c3a);
  border-left-color: var(--color-primary, #e9ae53);
  font-weight: 600;
}

.doc-nav-item .material-icons-sharp {
  font-size: 17px;
  min-width: 17px;
}

/* ====== Zone de contenu principale ====== */
.doc-main-area {
  flex: 1;
  height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 24px 30px 40px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.doc-main-area::-webkit-scrollbar {
  display: none;
}

/* Breadcrumb */
.doc-breadcrumb-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--color-info-dark, #7c8894);
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
}

/* Navigation page */
.doc-page-nav {
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
}

.doc-page-nav-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  background: var(--color-background, #f5f5f9);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.doc-page-nav-btn:hover {
  background: var(--color-primary-solve, #e9ae5329);
}

.doc-page-nav-btn small {
  font-size: 10px;
  color: var(--color-info-dark, #7c8894);
  display: block;
}

.doc-page-nav-btn span:not(.material-icons-sharp) {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-dark, #363949);
}

.doc-page-nav-btn .material-icons-sharp {
  font-size: 18px;
  color: var(--color-primary, #e9ae53);
}

/* Footer */
.doc-footer {
  text-align: center;
  padding: 24px 0 8px;
  border-top: 1px solid #eee;
  margin-top: 30px;
  color: var(--color-info-dark, #7c8894);
  font-size: 11px;
}

.doc-footer p {
  margin: 3px 0;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<!-- Styles globaux pour les composants enfants documentation -->
<style>
/* ====== Shared documentation section styles ====== */
.doc-section {
  max-width: 780px;
}

.doc-section .section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  padding-bottom: 12px;
  border-bottom: 3px solid var(--color-primary, #e9ae53);
}

.doc-section .section-header h2 {
  font-size: 20px;
  font-weight: 700;
  color: var(--color-dark, #363949);
  margin: 0;
}

.doc-section .section-icon {
  color: var(--color-primary, #e9ae53);
  font-size: 24px;
}

.doc-section .sub-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-dark, #363949);
  margin: 22px 0 8px;
}

.doc-section .section-text {
  font-size: 13px;
  color: var(--color-dark-variant, #677483);
  margin-bottom: 10px;
  line-height: 1.7;
}

/* Info cards */
.doc-section .info-card {
  background: var(--color-background, #f5f5f9);
  border-radius: 8px;
  padding: 16px 18px;
  margin: 12px 0;
  border-left: 4px solid var(--color-primary, #e9ae53);
}

.doc-section .info-card.tip {
  border-left-color: #6cbd7e;
  background: #f6fdf7;
}

.doc-section .info-card.warning {
  border-left-color: #ba4f4f;
  background: #fef6f6;
}

.doc-section .info-card.info {
  border-left-color: #5b9bd5;
  background: #f5f9fd;
}

.doc-section .info-card .card-title {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--color-dark, #363949);
}

.doc-section .info-card p {
  font-size: 12.5px;
  margin: 0;
  color: var(--color-dark-variant, #677483);
  line-height: 1.7;
}

/* Lists */
.doc-section .doc-list {
  padding-left: 20px;
  margin-bottom: 12px;
}

.doc-section .doc-list li {
  font-size: 13px;
  color: var(--color-dark-variant, #677483);
  margin-bottom: 5px;
  line-height: 1.6;
}

.doc-section .doc-list li strong {
  color: var(--color-dark, #363949);
}

/* Steps */
.doc-section .steps {
  margin: 12px 0;
}

.doc-section .step-item {
  background: var(--color-background, #f5f5f9);
  border-radius: 8px;
  padding: 14px 18px;
  margin-bottom: 8px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.doc-section .step-num {
  background: var(--color-primary, #e9ae53);
  color: #1e1e2f;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  margin-top: 1px;
}

.doc-section .step-item p {
  margin: 0;
  font-size: 13px;
  color: var(--color-dark-variant, #677483);
  line-height: 1.6;
}

.doc-section .step-item p strong {
  color: var(--color-dark, #363949);
}

/* Field reference boxes */
.doc-section .field-ref {
  background: var(--color-background, #f5f5f9);
  border-radius: 8px;
  padding: 14px 18px;
  margin: 10px 0;
  border: 1px solid #e0e0e0;
}

.doc-section .field-ref .field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--color-info-dark, #7c8894);
  margin-bottom: 8px;
}

.doc-section .field-ref ul {
  padding-left: 16px;
  margin: 0;
}

.doc-section .field-ref li {
  font-size: 12.5px;
  color: var(--color-dark-variant, #677483);
  margin-bottom: 3px;
}

.doc-section .field-ref li .req {
  color: #ba4f4f;
  font-weight: 700;
}

/* Tables */
.doc-section .table-wrapper {
  overflow-x: auto;
  margin: 12px 0;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.doc-section table {
  width: 100%;
  border-collapse: collapse;
  background: var(--color-white, #fff);
  font-size: 12.5px;
}

.doc-section thead {
  background: var(--color-dark, #363949);
  color: #fff;
}

.doc-section th {
  padding: 10px 14px;
  text-align: left;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.doc-section td {
  padding: 9px 14px;
  border-bottom: 1px solid #e0e0e0;
  color: var(--color-dark-variant, #677483);
  font-size: 12.5px;
  line-height: 1.5;
}

.doc-section tbody tr:hover {
  background: var(--color-background, #f5f5f9);
}

/* Section intro box */
.doc-section .section-intro {
  background: #f8f9fb;
  border-left: 4px solid var(--color-primary, #e9ae53);
  padding: 14px 18px;
  border-radius: 0 8px 8px 0;
  font-size: 13px;
  color: var(--color-dark-variant, #677483);
  line-height: 1.7;
  margin-bottom: 16px;
}

/* Required badge */
.doc-section .required-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.doc-section .badge-yes { background: #e8f5e9; color: #2e7d32; }
.doc-section .badge-no { background: #f3f3f3; color: #888; }
.doc-section .badge-cond { background: #fff3e0; color: #e65100; }

/* Button reference */
.doc-section .btn-ref {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: var(--color-primary, #e9ae53);
  color: #1e1e2f;
  padding: 3px 10px;
  border-radius: 5px;
  font-size: 11.5px;
  font-weight: 600;
}
.doc-section .btn-ref-dark {
  background: var(--color-dark, #363949);
  color: #fff;
}

/* Faq items */
.doc-section .faq-item {
  background: var(--color-background, #f5f5f9);
  border-radius: 8px;
  padding: 14px 18px;
  margin: 10px 0;
  border-left: 3px solid var(--color-primary, #e9ae53);
  transition: border-left-width 0.15s ease, box-shadow 0.15s ease;
}
.doc-section .faq-item:hover {
  border-left-width: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.doc-section .faq-item .faq-question {
  font-weight: 600;
  font-size: 13px;
  color: var(--color-dark, #363949);
  margin: 0 0 6px;
  cursor: default;
}
.doc-section .faq-item .faq-question::before {
  content: "Q : ";
  color: var(--color-primary, #e9ae53);
  font-weight: 700;
}
.doc-section .faq-item .faq-answer {
  font-size: 12.5px;
  color: var(--color-dark-variant, #677483);
  line-height: 1.7;
}
.doc-section .faq-item .faq-answer p { margin: 0; }

/* Step items hover */
.doc-section .step-item {
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}
.doc-section .step-item:hover {
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

/* Info cards hover */
.doc-section .info-card {
  transition: box-shadow 0.15s ease;
}
.doc-section .info-card:hover {
  box-shadow: 0 3px 12px rgba(0,0,0,0.07);
}

/* Table row zebra striping */
.doc-section tbody tr:nth-child(even) {
  background: #fafbfc;
}

/* Strong in td */
.doc-section td strong {
  color: var(--color-dark, #363949);
}

/* Role badges */
.doc-section .role-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10.5px;
  font-weight: 600;
}
.role-admin { background: #ffebee; color: #c62828; }
.role-finance { background: #e8f5e9; color: #2e7d32; }
.role-operations { background: #e3f2fd; color: #1565c0; }
.role-caisse { background: #fff3e0; color: #e65100; }
.role-magasinier { background: #f3e5f5; color: #7b1fa2; }
.role-controleur { background: #e0f7fa; color: #00695c; }
.role-accueil { background: #fce4ec; color: #ad1457; }
</style>
